import { render, staticRenderFns } from "./ModalUpdateArboSnapshot.vue?vue&type=template&id=0cb2546c&"
import script from "./ModalUpdateArboSnapshot.vue?vue&type=script&lang=js&"
export * from "./ModalUpdateArboSnapshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports